<template>
  <div>
  <!-- <div style="background-color: rgba(131, 164, 172, 0.7); padding: 20px; border-radius: 5px; margin-bottom: 20px" > -->

    <el-row style="margin: 10px 0px" align="left">
      <el-col :offset="1" :span="20" align="left">
        <el-radio-group v-model="timeInterval" size="small">
          <el-radio-button label="Daily" ></el-radio-button>
          <el-radio-button label="Weekly"></el-radio-button>
          <el-radio-button label="Monthly"></el-radio-button>
        </el-radio-group>
        <el-button v-if="timeInterval === 'Daily'" :disabled="playDisabled" @click="playTimelapse()" type="info" size="mini" style="margin-left: 20px">
          <i class="fas icon-fa-play"></i>
        </el-button>
        <el-button v-if="timeInterval === 'Daily'" @click="pauseTimelapse()" type="info" size="mini" style="margin-left: 5px">
          <i class="fas icon-fa-pause"></i>
        </el-button>
        <el-button v-if="timeInterval === 'Daily'" @click="resetTimelapse()" type="info" size="mini" style="margin-left: 5px">
          <i class="fas icon-fa-sync-alt"></i>
        </el-button>
      </el-col>
    </el-row>

    <el-row>
      <div class="echarts" style="height: 150px;">
        <v-chart :option='scatterOptions' :resizable="true" theme="infographic" @datazoom="zoomCallback"></v-chart>
      </div>
    </el-row>
    
    <el-row style="margin: 20px 0px">
      <el-col :span="12" style="padding: 10px">
        <div class="echarts" style="width: 100%; height: 500px" >
          <div> First identified in the state of <b>{{ firstIdentifiedState }}</b> </div>
          <v-chart :option='geomapOptions'  id="variant-data-geomap" :resizable="true" theme="infographic"></v-chart>
        </div>
      </el-col>
      <el-col :span="12" style="padding: 10px">
        <div class="echarts" style="width: 100%; height: 500px" >
          <v-chart :option='cladePieOptions'  id="clade-pie" :resizable="true" theme="infographic"></v-chart>
        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import { store } from '@/scripts/store.js'
import IEcharts from 'vue-echarts-v3/src/full.js'


const _ = require('lodash')
const echarts = require('echarts')

export default {
  name: 'VariantDataGeomapTimeline',
  components: {
    'v-chart': IEcharts,
  },
  data() {
    return { 
      store: store,
      timeInterval: 'Daily',
      show: false,
      firstIdentifiedState: '',
      filterStartPercent: 0, filterEndPercent: 100,
      startDate: 0, endDate: 0,
      filterStartDate: 0, filterEndDate: 0,
      allWeeks: [],
      startWeek: '', endWeek: '',
      filterStartWeek: '', filterEndWeek: '',
      allMonths: [],
      startMonth: '', endMonth: '',
      filterStartMonth: '', filterEndMonth: '',
      playDisabled: false, playActive: false,
      timers: [], startTimer: 0,
      cycleNumber: 0,
    }
  },
  props: {
    height: String,
    geomapTimelineData: Object,
  },
  async mounted() {
    const context = this
    this.loadChart()
  },
  methods: {
    loadChart: function() {
      const context = this
      const data = context.geomapTimelineData
      const dates = (_.uniq(data.date)).sort()

      context.startDate = Date.parse(dates[0])
      context.filterStartDate = Date.parse(dates[0])
      context.endDate = Date.parse(dates[dates.length - 1])
      context.filterEndDate = Date.parse(dates[dates.length - 1])

      const weeks = _.sortBy(_.uniq(data.week), d => { return d.split('-')[1] + `${d.split('-')[0]}`.padStart(2, '0') })
      const firstDate = _.min(data.date)
      const firstInstanceIndex = data.date.indexOf(firstDate)
      context.firstIdentifiedState = data.state[firstInstanceIndex]
      
      const minWeekDate = weeks[0]
      const maxWeekDate = weeks[weeks.length - 1]
      const minYear = parseInt(minWeekDate.split('-')[1])
      const maxYear = parseInt(maxWeekDate.split('-')[1])
      const minWeek = parseInt(minWeekDate.split('-')[0])
      const maxWeek = parseInt(maxWeekDate.split('-')[0])
      const allWeeks = []
      for(let year=minYear; year <= maxYear; year++) { 
        const weekMinLimit = (year === minYear) ? minWeek : 0
        const weekMaxLimit = (year === maxYear) ? maxWeek : 52
        for(let week=weekMinLimit; week <= weekMaxLimit; week++) {
          const key = `${week}-${year}`
          allWeeks.push(key)
        }
      }
      context.allWeeks = allWeeks
      context.startWeek = allWeeks[0]
      context.endWeek = allWeeks[allWeeks.length - 1]
      context.filterStartWeek = allWeeks[0]
      context.filterEndWeek = allWeeks[allWeeks.length - 1]

      const allMonths = []
      const months = _.uniq(_.map(dates, d => { return  `${d.split('-')[1]}-${d.split('-')[0]}` }))
      const minMonth = parseInt(months[0].split('-')[0])
      const maxMonth = parseInt(months[months.length - 1].split('-')[0])
      for(let year=minYear; year <= maxYear; year++) { 
        const monthMinLimit = (year === minYear) ? minMonth : 1
        const monthMaxLimit = (year === maxYear) ? maxMonth : 12
        for(let month=monthMinLimit; month <= monthMaxLimit; month++) {
          const key = `${month}`.padStart(2, '0') + '-' + year
          allMonths.push(key)
        }
      }
      context.allMonths = allMonths
      context.startMonth = allMonths[0]
      context.endMonth = allMonths[allMonths.length - 1]
      context.filterStartMonth = allMonths[0]
      context.filterEndMonth = allMonths[allMonths.length - 1]
    },
    zoomCallback: function(val) {
      const context = this
      let startVal = 0
      let endVal = 0
      if (val.batch === undefined) {
        startVal = val.start; endVal = val.end;
      } else {
        startVal = val.batch[0].start; endVal = val.batch[0].end;        
      }

      context.filterStartPercent = startVal
      context.filterEndPercent = endVal

      if (context.timeInterval === 'Daily') {
        const diff = context.endDate - context.startDate
        context.filterStartDate = Math.round(context.startDate + (diff*startVal)/100)
        context.filterEndDate = Math.round(context.startDate + (diff*endVal)/100)
      }
      else if (context.timeInterval === 'Weekly') {
        const numWeeks = context.allWeeks.length
        context.filterStartWeek = context.allWeeks[Math.round((startVal/100)*numWeeks)]
        context.filterEndWeek = context.allWeeks[Math.round((endVal/100)*numWeeks) - 1]
      }
      else if (context.timeInterval === 'Monthly') {
        const numMonths = context.allMonths.length
        context.filterStartMonth = context.allMonths[Math.round((startVal/100)*numMonths)]
        context.filterEndMonth = context.allMonths[Math.round((endVal/100)*numMonths) - 1]
      }
    },
    playTimelapse: function() {
      const context = this
      context.playDisabled = true
      const timeDelay = 1000
      const interval = 5
      const total = 100
      if (!(context.playActive)) {
        context.startTimer = Date.now()
        context.playActive = true
      }
      for (let i=context.cycleNumber; i<parseInt(total - interval); i++) {
        context.timers.push(setTimeout(() => {
          context.filterStartPercent = 0
          context.filterEndPercent = (i+1)*interval
          context.cycleNumber = i+1
          context.zoomCallback({ start: i, end: i+interval })
          if (i == (parseInt(total/interval) - 1)) {
            context.playActive = false
            context.cycleNumber = 0
          }
        }, timeDelay*(i+1-context.cycleNumber)))
      }

    },
    pauseTimelapse: function() {
      const context = this
      const timeDelay = 1000
      const timeDifference = Date.now() - context.startTimer
      const cycle = parseInt(timeDifference/timeDelay)
      context.timers.forEach(d => { window.clearTimeout(d) })
      context.playDisabled = false
    },
    resetTimelapse: function() {
      const context = this
      context.timers.forEach(d => { window.clearTimeout(d) })
      context.filterStartPercent = 0
      context.filterEndPercent = 100
      context.zoomCallback({ start: 0, end: 100 })
      context.playDisabled = false
    }
  },
  computed: {
    indiaData() {
      return store.datasets.indiaGeomapTimeline
    },
    scatterOptions: function() {
      const context = this
      const data = context.geomapTimelineData
      const dates = (_.uniq(data.date)).sort()

      const axisColor = store.theme.viewMode.axisColor[store.theme.viewMode.active]
      const startVal = context.filterStartPercent
      const endVal = context.filterEndPercent

      const options = {
        grid: [{ left: 50, right: 20, top: 20 }],
        textStyle: { fontFamily: store.theme.fontFamily.content, fontWeight: 'bold', color: axisColor },
        tooltip: { 
          show: true, trigger: 'axis', axisPointer: { type: 'shadow' }, 
          formatter: function(data) {
            return `
              <div>${data[0].data[0]}</div>
              <div style="font-size: 20px; text-align: left">${data[0].data[1]}% (${data[0].data[2]}/${data[0].data[3]})</div>
            `
          },
          textStyle: { color: '#4e4e4e', fontFamily: store.theme.fontFamily.plotTooltip, fontWeight: 'normal' }, padding: 10, 
          backgroundColor: '#ffffff'
        },
        dataZoom: [{
          type: 'slider', xAxisIndex: 0,
          textStyle: { color: axisColor },
          height: 5, bottom: 10, handleSize: '350%',
          backgroundColor: 'rgba(233, 71, 49, 0.5)',
          borderColor: '#4e4e4e',
          handleIcon: "M10.467,146.589l198.857,252.903c17.418,30.532,45.661,30.532,63.079,0l198.839-252.866    c3.88-5.533,8.072-15.41,8.923-22.118c2.735-21.738,4.908-65.178-21.444-65.178H23.013c-26.353,0-24.192,43.416-21.463,65.147    C2.395,131.185,6.587,141.051,10.467,146.589z",
          dataBackground: {
            lineStyle: { shadowColor: '', opacity: 0 },
            areaStyle: { color: 'blue', shadowColor: '#374455', opacity: 0 }
          }, realtime: false,
          handleStyle: { color: '#7d7d7d', },
          fillerColor: '#172231', start: startVal, end: endVal,
          // startValue: Date.parse(dates[0]), endValue: Date.parse(dates[dates.length - 1]),
          filterMode: 'filter', rangeMode: ['value', 'value'],
        }],
        xAxis: {
          type: 'time', axisLine: { lineStyle: { opacity: 1, color: axisColor } },
          splitLine: { show: false }, 
          axisLabel: { 
            fontSize: 10,
            formatter: function(d) {
              const date = new Date(d)
              return `${date.getUTCDate()+1} ${store.constants.months[parseInt(date.getUTCMonth())]}'${date.getUTCFullYear()-2000}`
            }
          },
          axisTick: { alignWithLabel: true }
        },
        yAxis: {
          axisLabel: { show: true, fontSize: 10, color: axisColor }, axisLine: { show: false },
          splitLine: { lineStyle: { color: axisColor, type: 'dotted' } }, splitNumber: 2,
        },
        series: [{
          data: [], type: 'bar', areaStyle: { opacity: 1 },
          itemStyle: { color: '#539497' }, symbol: 'none'
        }],
        resize: true, animation: true,
      }


      if (context.timeInterval === 'Daily') {
        const dateCounts = {}
        data.date.forEach((o, i) => {
          if (o in dateCounts) { dateCounts[o] += data.count[i] }
          else { dateCounts[o] = data.count[i] }
        })

        const indiaDateCounts = {}
        context.indiaData.date.forEach((o,i) => {
          if (o in indiaDateCounts) { indiaDateCounts[o] += context.indiaData.count[i] }
          else { indiaDateCounts[o] = context.indiaData.count[i] }
        })

        options.series[0].data = _.map(dates, d => {
          return [d, ((dateCounts[d]/indiaDateCounts[d])*100).toFixed(2), dateCounts[d], indiaDateCounts[d]]
        })
      }

      else if (context.timeInterval === 'Weekly') {
        const allWeeks = context.allWeeks
        const weekCounts = {}

        data.week.forEach((w, i) => {
          if (w in weekCounts) { weekCounts[w] += data.count[i] }
          else { weekCounts[w] = data.count[i] }
        })

        const indiaWeekCounts = {}
        context.indiaData.week.forEach((w,i) => {
          if (w in indiaWeekCounts) { indiaWeekCounts[w] += context.indiaData.count[i] }
          else { indiaWeekCounts[w] = context.indiaData.count[i] }
        })

        const xLabels = _.map(allWeeks, label => { return `W ${label.split('-')[0]}'${label.split('-')[1].substring(2,4)}` })
        options.series[0].data = _.map(allWeeks, (week, w) => { 
            if (indiaWeekCounts[week] === undefined) {
              return [w, 0, 0, 0]
            } else {
              const val = (weekCounts[week] !== undefined) ? weekCounts[week] : 0
              return [w, ((val/indiaWeekCounts[week])*100).toFixed(2), val, indiaWeekCounts[week]] 
            }            
        })
        options.tooltip.formatter = function(data) {
          return `
            <div style="text-align: left">${xLabels[data[0].data[0]]}</div>
            <div style="font-size: 20px; text-align: left">${data[0].data[1]}% (${data[0].data[2]}/${data[0].data[3]})</div>
          `
        }
        options.xAxis.type = 'category'
        options.xAxis.axisLabel.formatter = function(a) { return xLabels[a] }
        options.xAxis.axisLabel.rotate = 45
        options.dataZoom[0].labelFormatter = function(d){ return xLabels[d] }
      }

      else if (context.timeInterval === 'Monthly') {
        const allMonths = context.allMonths
        const monthCounts = {}

        data.date.forEach((d, i) => {
          const month = `${d.split('-')[1]}-${d.split('-')[0]}`
          if (month in monthCounts) { monthCounts[month] += data.count[i] }
          else { monthCounts[month] = data.count[i] }
        })

        const indiaMonthCounts = {}
        context.indiaData.date.forEach((d,i) => {
          const month = `${d.split('-')[1]}-${d.split('-')[0]}`
          if (month in indiaMonthCounts) { indiaMonthCounts[month] += context.indiaData.count[i] }
          else { indiaMonthCounts[month] = context.indiaData.count[i] }
        })

        const xLabels = _.map(allMonths, label => { return `${store.constants.months[parseInt(label.split('-')[0])-1]}'${label.split('-')[1].substring(2,4)}` })
        options.series[0].data = _.map(allMonths, (month, m) => { 
            if (indiaMonthCounts[month] === undefined) {
              return [m, 0, 0, 0]
            } else {
              const val = (monthCounts[month] !== undefined) ? monthCounts[month] : 0
              return [m, ((val/indiaMonthCounts[month])*100).toFixed(2), val, indiaMonthCounts[month]] 
            }            
        })
        options.tooltip.formatter = function(data) {
          return `
            <div style="text-align: left">${xLabels[data[0].data[0]]}</div>
            <div style="font-size: 20px; text-align: left">${data[0].data[1]}% (${data[0].data[2]}/${data[0].data[3]})</div>
          `
        }
        options.xAxis.type = 'category'
        options.xAxis.axisLabel.formatter = function(a) { return xLabels[a] }
        options.xAxis.axisLabel.rotate = 45
        options.dataZoom[0].labelFormatter = function(d){ return xLabels[d] }
      }

      return options
    },
    geomapOptions() {

      const indiaMap = store.maps.india.states
      echarts.registerMap('india', indiaMap)

      const context = this
      const data = (context.geomapTimelineData !== undefined) ? context.geomapTimelineData : {}
      const axisColor = store.theme.viewMode.axisColor[store.theme.viewMode.active]

      const stateCounts = {}
      const states = (_.uniq(data.state))
      if (context.timeInterval == 'Daily') {
        data.state.forEach((o, i) => {
          const date = Date.parse(data.date[i])
          if ( context.filterStartDate <= date && date <= context.filterEndDate) {
            if (o in stateCounts) {stateCounts[o] += data.count[i] }
            else { stateCounts[o] = data.count[i] }
          }
        })
      }

      else if (context.timeInterval === 'Weekly') {
        data.state.forEach((o, i) => {
          const weekDate = data.week[i]
          const minWeekDate = context.filterStartWeek
          const maxWeekDate = context.filterEndWeek
          const weeks = _.sortBy([weekDate, maxWeekDate, minWeekDate], d => { return d.split('-')[1] + `${d.split('-')[0]}`.padStart(2, '0') })
          if (weeks[1] == weekDate) {
            if (o in stateCounts) {stateCounts[o] += data.count[i] }
            else { stateCounts[o] = data.count[i] }
          }
        })  
      }

      else if (context.timeInterval === 'Monthly') {
        data.state.forEach((o, i) => {
          const date = data.date[i]
          const month = `${date.split('-')[0]}-${date.split('-')[1]}`
          const minMonth = `${context.filterStartMonth.split('-')[1]}-${context.filterStartMonth.split('-')[0]}`
          const maxMonth = `${context.filterEndMonth.split('-')[1]}-${context.filterEndMonth.split('-')[0]}`
          const months = [month, maxMonth, minMonth].sort()
          if (months[1] == month) {
            if (o in stateCounts) {stateCounts[o] += data.count[i] }
            else { stateCounts[o] = data.count[i] }
          }
        })  
      }
      const geomapPlotData = []
      let maxCount = 0
      states.forEach((o,i) => {
        if (stateCounts[o] > maxCount) { maxCount = stateCounts[o] }
        geomapPlotData.push({name: o, value: stateCounts[o]})
      })

      return {
        textStyle: { fontFamily: store.theme.fontFamily.content },
        toolbox: {
          feature: {  
            saveAsImage: { title: 'Save as PNG', show: true, type: 'png', name: 'StateContributions_Map' },
          }
        },
        emphasis: {
          show: false,
          label: { fontWeight: 'bold' }
        },
        // tooltip: {
        //   trigger: 'item', showDelay: 0, transitionDuration: 0.2,
        //   formatter: function (params) {
        //     const val = (isNaN(params.value)) ? 0 : params.value
        //     return params.name + '<br/>' + params.seriesName + ': ' + val;
        //   },
        //   position: [10,10],
        //   textStyle: { fontWeight: 'bold' }
        // },
        visualMap: {
          left: 10, bottom: 20, min: 1, max: maxCount, orient: 'vertical',
          itemWidth: 8, itemHeight: 50, seriesIndex: [0],
          inRange: {
            color: ['#fdff7a', '#b82525'],
          },
          text: ['Max', 'Min'], calculable: true, 
          textStyle: { fontWeight: 'bold', color: axisColor },

        },
        geo: {
          id: 'country', show: true, map: 'india', aspectScale: 0.9, zoom: 1, roam: false, 
          itemStyle: { borderColor: '#919191', borderWidth: 1.4, borderType: 'dotted', areaColor: 'rgba(255,255,255,0)'},
          emphasis:{
            itemStyle: {
              areaColor: '#dedede', shadowOffsetX: 0, shadowOffsetY: 0,
              shadowBlur: 20, borderWidth: 0, shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
            label: {
              formatter: function(d) {
                const state = d.name
                const value = _.filter(geomapPlotData, d => { return d.name === state })
                if (value.length > 0) {
                  return `${state}: ${value[0].value} genomes`
                }
                else { return `${state}: 0 genomes` }
              },
              backgroundColor: 'rgba(255, 255, 255, 0.7)', padding: 10,
              borderRadius: 8, borderColor: 'rgba(100, 100, 100)', borderWidth: 1,
              position: [10, 10]
            }
          }
        },
        series: [
          { 
            type: 'map', name: '#Genomes', geoIndex: 0, data: geomapPlotData,
            label: { position: 'inside' }
          },
        ], resize: true,
      }
    },
    cladePieOptions() {
      const context = this
      const data = (context.geomapTimelineData !== undefined) ? context.geomapTimelineData : {}
      const axisColor = store.theme.viewMode.axisColor[store.theme.viewMode.active]
      const stateCladeCounts = {}
      const cladeCounts = {}
      const clades = _.uniq(data.clade)
      clades.forEach(c => { cladeCounts[c] = 0 })

      if (context.timeInterval == 'Daily') {
        data.clade.forEach((clade, i) => {
          const date = Date.parse(data.date[i])
          if ( (context.filterStartDate <= date) && (date <= context.filterEndDate)) {
            cladeCounts[clade] += data.count[i]
          }
        })
      }

      else if (context.timeInterval === 'Weekly') {
        data.clade.forEach((clade, i) => {
          const weekDate = data.week[i]
          const minWeekDate = context.filterStartWeek
          const maxWeekDate = context.filterEndWeek
          const weeks = _.sortBy([weekDate, maxWeekDate, minWeekDate], d => { return d.split('-')[1] + `${d.split('-')[0]}`.padStart(2, '0') })
          if (weeks[1] == weekDate) { cladeCounts[clade] += data.count[i] }
        })  
      }

      else if (context.timeInterval === 'Monthly') {
        data.clade.forEach((clade, i) => {
          const date = data.date[i]
          const month = `${date.split('-')[0]}-${date.split('-')[1]}`
          const minMonth = `${context.filterStartMonth.split('-')[1]}-${context.filterStartMonth.split('-')[0]}`
          const maxMonth = `${context.filterEndMonth.split('-')[1]}-${context.filterEndMonth.split('-')[0]}`
          const months = [month, maxMonth, minMonth].sort()
          if (months[1] == month) { cladeCounts[clade] += data.count[i]}
        })  
      }

      
      const cladePiePlotData = []
      clades.forEach(d => { cladePiePlotData.push({ name: d, value: cladeCounts[d] }) })
      const series = [{
        type: 'pie', data: cladePiePlotData,
        center: ['50%', '50%'], radius: ['35%', '60%'],
        labelLine: { length: 10, length2: 10 }, 
        label: {
          formatter: (d) => {return `${d.name} (${d.value})`},
          fontSize: 14, overflow: 'none'
        },
        itemStyle: { color: function(d) { return store.theme.colors.nextstrain_clades[d.name] }, opacity: 0.95},
      }]
      return {
        grid: {left: 5},
        textStyle: { fontFamily: store.theme.fontFamily.content, fontWeight: 'bold', color: axisColor },
        legend: { show: true, top: 8, left: "right", orient: 'vertical', type: 'scroll', itemHeight: 12, itemWidth: 12, textStyle: { fontSize: 14, color: axisColor } },
        tooltip: { 
          show: true, trigger: 'item',textStyle: { fontFamily: store.theme.fontFamily.plotTooltip, color: '#4e4e4e', fontWeight: 'normal' },
          borderColor: '#bebebe', borderWidth: 1,
          backgroundColor: 'rgba(250,250,250,1)', padding: 10,
          formatter: function(d) { 
            return `Genomes<br>\
            <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${store.theme.colors.clades[d.data.name]};"></span>\
            ${d.data.name}: ${d.data.value}` 
          }
        },
        resize: true, series: series,
      }
    }
  }
}
</script>

<style>
  
</style>